<template>
  <div id="fee20211117" style="position:relative;">
    <el-dialog title="收款信息" append-to-body :visible.sync="billPayBoxFlag">
      <div v-loading="queryLoading">
        <div style="display:flex;text-align:center;padding-bottom:1rem;">
          <div style="flex:1">房间:{{ communityName }}</div>
          <div style="flex:1">客户：{{ zhxx.householder }}</div>
          <div style="flex:1">费用合计：{{ totalShouldAmount }}元</div>
        </div>
        <h3 style="color: red;    text-align: center;">{{ billToast }}</h3>
        <div style="padding:1rem 0;">
          <el-table
            show-summary
            :data="payInfo2.payDetailList"
            border
            height="200px"
            class="bill-table2"
          >
            <el-table-column prop="feeName" label="费用名称"></el-table-column>
            <el-table-column prop="feePeriod" label="账期"></el-table-column>
            <el-table-column prop="calAmount" label="费用金额" width="100px"></el-table-column>
            <el-table-column prop="delayAmount" label="滞纳金" width="100px"></el-table-column>
            <el-table-column prop="derateAmount" label="优惠金额" width="100px"></el-table-column>
            <el-table-column prop="couponAmount" label="抵扣金额" width="100px"></el-table-column>
            <el-table-column
              prop="accountpayAmount"
              label="账户抵扣余额"
              width="100px"
            ></el-table-column>
            <el-table-column prop="shouldAmount" label="应收金额" width="100px"></el-table-column>
          </el-table>
        </div>
        <avue-form
          ref="billPayForm"
          v-if="billPayBoxFlag"
          :option="billPayFormOption"
          v-model="billPayForm"
        >
          <template slot="couponCode">
            <div>
              <el-input
                type="text"
                v-model="billPayForm.couponCode"
                style="width:100%"
                maxlength="20"
                placeholder="请输入优惠券码"
              >
                <el-button type="primary" slot="append" @click="queryCouponCode">查询</el-button>
              </el-input>
            </div>
          </template>
          <template slot="depositId">
            <div>
              <el-input
                style="width:100%"
                v-model="depositName"
                placeholder="请选择押金种类"
                :readonly="true"
              >
                <i
                  v-show="depositName"
                  slot="suffix"
                  class="el-input__icon el-icon-circle-close"
                  @click="clearDeposit"
                ></i>
                <el-button type="primary" slot="append" @click="isDepositDialogShow = true">
                  选择
                </el-button>
              </el-input>
            </div>
          </template>
          <template slot="authCode">
            <!-- v-if="showAuthCodeFlag" -->
            <el-input
              type="password"
              ref="authCodeInput"
              v-model="billPayForm.authCode"
              @blur="blurHandler"
              @input="inputHandler"
              @focus="focusHandler"
              maxlength="18"
              placeholder="请输入优惠券码"
            ></el-input>
          </template>
          <template slot="payType">
            <el-select v-model="billPayForm.payType" @change="payTypeChange">
              <el-option
                v-for="item in payTypeList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </template>

          <template slot="payScene">
            <el-select v-model="billPayForm.payScene" @change="paySceneChange">
              <el-option
                v-for="item in paySceneList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </template>
        </avue-form>
        <div style="padding:1rem;overflow:hidden;">
          <div style="float:right;">
            <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
            <el-button @click="cancelPay" type="normal">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- <div style="margin:1rem 0;">
                <el-button type="primary" size="small" @click="billPay_">
                    账单收费
                </el-button>
                <el-button type="primary" size="small" @click="createBill">
                    生成账单
                </el-button>
        </div> -->
    <div style="display:flex;padding-bottom:1rem;">
      <div style="flex: 1;">
        <div class="sum-tips">
          <span>{{ '户主: ' + (zhxx.householder ? zhxx.householder + '(' + zhxx.linkPhone + ')' : '无') }}</span>
          <span>{{ '房号: ' + (zhxx.fullName || '无') }}</span>
          <span>{{ '建筑面积: ' + (zhxx.floorAge || '无') }}</span>
        </div>
        <div>{{ '欠缴信息：' + descText }}</div>
      </div>
      <div style="text-align:right;">
        <el-button
          size="small"
          icon="el-icon-refresh"
          circle
          :disabled="subjectDisabledFlag"
          @click="refreshHandler"
        ></el-button>
      </div>
    </div>
    <div class="feeItemSelectBox" style="width:50%;margin-left:2rem;display:inline-block;">
      <span>收费科目: </span>
      <el-select
        style="width:30rem!important;"
        multiple
        :disabled="subjectDisabledFlag"
        v-model="subjectIds"
        @change="subjectIdChange"
      >
        <el-option
          v-for="item in subjectList"
          :key="item"
          :value="item.dictKey"
          :label="item.dictValue"
        >
        </el-option>
      </el-select>
    </div>
    <avue-crud
      :data.sync="tableData"
      :option="option"
      ref="avueCrud"
      @selection-change="selectionChange"
      :page.sync="page"
    >
      <template slot="calAmount" slot-scope="sp">
        <span style="text-align:right">{{ tool.money_format_allowvoid(sp.row.calAmount) }}</span>
      </template>
      <template slot="delayAmount" slot-scope="sp">
        <span>{{ tool.money_format_allowvoid(sp.row.delayAmount) }}</span>
      </template>
      <template slot="billPreferentAmount" slot-scope="sp">
        <span> {{ tool.money_format_allowvoid(sp.row.billPreferentAmount) }} </span>
      </template>
      <template slot="billCouponAmount" slot-scope="sp">
        <span> {{ tool.money_format_allowvoid(sp.row.billCouponAmount) }} </span>
      </template>
      <template slot="billShouldAmount" slot-scope="sp">
        <span> {{ tool.money_format_allowvoid(sp.row.billShouldAmount) }} </span>
      </template>
      <template slot="accountpayAmount" slot-scope="sp">
        <span> {{ tool.money_format_allowvoid(sp.row.accountpayAmount) }} </span>
      </template>
      <template slot="lockFlag" slot-scope="sp">
        <div>{{ getLockFlagStatus(sp.row.lockFlag) }}</div>
      </template>
    </avue-crud>
    <div style="position:absolute;left:0rem;bottom:2rem;">
      <el-button type="primary" size="small" @click="billPay_">
        账单收费
      </el-button>
      <el-button type="primary" size="small" @click="createBill">
        生成账单
      </el-button>
      <el-button type="primary" size="small" v-if="permission.propertyCharge_reduceFee" @click="reduceFee">
        减免
      </el-button>
      <el-button type="primary" size="small" v-if="permission.propertyCharge_offBill" @click="offBill">
        销账
      </el-button>
    </div>
    <el-dialog title="减免" fullscreen append-to-body :visible.sync="reduceBoxFlag">
      <div v-if="reduceBoxFlag">
        <div class="reduce-top">
          <span>减免总金额</span>
          <moneyInput v-model="reduceAmount" placeholder=" " style="width: 200px;" />
          <el-button @click="applyReduce" type="primary" size="small">应用</el-button>
        </div>
        <avue-crud :option="reduceTableOption" :data="reduceTableData" :cell-style="reduceTableCellStyle"></avue-crud>
        <avue-form ref="reduceForm" :option="reduceFormOption" v-model="reduceFormData"></avue-form>
        <div style="display: flex; justify-content: flex-end;">
          <el-button @click="doReduce" type="primary" size="small">保存</el-button>
          <el-button @click="doCancel('reduce')" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="销账" append-to-body :visible.sync="offBillBoxFlag">
      <div v-if="offBillBoxFlag">
        <avue-form ref="offBillForm" :option="offBillFormOption" v-model="offBillFormData"></avue-form>
        <div style="display: flex; justify-content: flex-end;">
          <el-button @click="doOffBill" type="primary" size="small">保存</el-button>
          <el-button @click="doCancel('offBill')" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- <el-table
        @selection-change="selectionChange"
        :data="tableData"
        stripe
        border

        :max-height="maxHeight"
        highlight-current-row
        style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
        <el-table-column
              prop="billFeeItemName"
              label="费用名称"
              width="250px"
            ></el-table-column>
            <el-table-column
              prop="billcycleNo"
              label="账单周期编码"
              width="120px"
            ></el-table-column>
            <el-table-column
              prop="billStartDate"
              label="账单开始时间"
              width="130px"
            ></el-table-column>
            <el-table-column
              prop="billEndDate"
              label="账单结束时间"
              width="130px"
            ></el-table-column>
            <el-table-column prop="calAmount" label="理论金额"></el-table-column>
            <el-table-column prop="delayAmount" label="滞纳金"></el-table-column>
            <el-table-column prop="billPreferentAmount" label="政策优惠"></el-table-column>
            <el-table-column prop="billCouponAmount" label="优惠券抵扣"></el-table-column>
            <el-table-column prop="billShouldAmount" label="应收金额"></el-table-column>

            <el-table-column label="划扣账单状态">
              <template slot-scope="sp">
                <div>{{ getLockFlagStatus(sp.row.lockFlag) }}</div>
              </template>
            </el-table-column>
        </el-table> -->

    <el-dialog
      title="查询中"
      :visible.sync="statusDialogVisible"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode_"
    >
      <div style="text-align: center; color: #ff0000; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.payStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div>倒计时：{{ statusDuration }}</div>
      </div>
    </el-dialog>

    <el-dialog
      :title="payScene == 6 ? '查询中' : '收款码'"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: #ff0000; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.payStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcode" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>

    <el-dialog title="生成账单" append-to-body :visible.sync="billGenerateFormFlag">
      <avue-form
        ref="billGenerateForm"
        v-if="billGenerateFormFlag"
        :option="billGenerateFormOption"
        v-model="billGenerateForm"
      >
        <template slot="subjectId">
          <el-select v-model="billGenerateForm.subjectId" @change="billGenerateSubjectIdChange">
            <el-option
              v-for="item in subjectList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="cycle">
          <el-input
            v-model="billGenerateForm.cycle"
            @input="cycleInput"
            @blur="cycleBlur"
            maxlength="3"
          ></el-input>
        </template>
      </avue-form>
      <div style="text-align:center;">
        <el-button type="primary" @click="submitBillCreate" v-loading="submitBillLoadingFlag">
          生成账单
        </el-button>
        <el-button @click="cancelBillCreate">
          取消
        </el-button>
      </div>
    </el-dialog>
    <!-- 选择押金种类的弹框 -->
    <el-dialog
      v-if="isDepositDialogShow"
      title="选择押金种类"
      width="60%"
      :visible.sync="isDepositDialogShow"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <DepositTypeList
        :propertyId="targetId"
        @update="updateDepositObj"
        @close="isDepositDialogShow = false"
      ></DepositTypeList>
    </el-dialog>
    <printPreview ref="printPreview" style="height:0px;"></printPreview>
  </div>
</template>
<script>
import _ from 'lodash';
import QRCode from 'qrcodejs2';
import dayjs from 'dayjs';
import {
  getFeeBillOweDesc,
  getFeeBillList,
  getPayTypeList,
  getPaySceneListNew,
  loadPayStatusChannelV1,
  loadPayStatusPlatformV1,
  queryCouponCode,
  getDict,
  billPayNewSubmit,
  getGenerateItemsetList,
  getGenerateEnddate,
  generateFeeBill,
  reduction as reductionApi,
  offBill as offBillApi,
  getBusinessNo,
} from '@/api/charge/charge-pay';
import {
  bankBillStatus,
  updateBill,
  loadBill,
  loadZhxx,
  getBillPayCalculateList,
} from '@/api/charge';
import { mapGetters } from 'vuex';
import printPreview from '@/views/v4ward/pay/printdialog-new/printPreview';
import DepositTypeList from '../deposit-type-list';
import { deepClone } from '@/util/util'

export default {
  components: { printPreview, DepositTypeList },
  props: ['targetId'],
  data() {
    return {
      isDepositDialogShow: false, // 押金种类选择的弹框是否显示着
      depositName: '', // 押金种类名称
      billToast: '',
      submitBillLoadingFlag: false,
      paySubmitBtn: true,
      page: {
        pageSize: 100,
        currentPage: 1,
        total: 0,
        pageSizes: [100],
      },
      option: {
        index: true,
        indexLabel: '序号',
        selection: true,
        border: true,
        height: '800',
        maxHeight: '800',
        // calcHeight:"auto",
        header: false,
        align: 'left',
        titlePosition: 'center',
        menu: false,
        stripe: true,
        column: [
          {
            prop: 'billFeeItemName',
            label: '费用类别',
          },
          {
            prop: 'billcycleNo',
            label: '账单周期',
          },
          {
            prop: 'billStartDate',
            label: '账单开始时间',
          },
          {
            prop: 'billEndDate',
            label: '账单结束时间',
          },
          {
            prop: 'calAmount',
            label: '理论金额',
            align: 'right',
            slot: true,
          },
          {
            prop: 'delayAmount',
            label: '滞纳金',
            align: 'right',
            slot: true,
          },
          {
            prop: 'billPreferentAmount',
            label: '政策优惠',
            align: 'right',

            slot: true,
          },
          {
            prop: 'billCouponAmount',
            label: '优惠券抵扣',
            align: 'right',
            slot: true,
          },
          {
            prop: 'accountpayAmount',
            label: '账户余额抵扣',
            align: 'right',
            slot: true,
          },
          {
            prop: 'billShouldAmount',
            label: '应收金额',
            align: 'right',
            slot: true,
          },
          {
            prop: 'lockFlag',
            label: '划扣账单状态',
            align: 'left',
            slot: true,
          },
          {
            prop: 'reductionFlag',
            label: '是否减免',
            formatter: (row) => {
              return row.reductionFlag == 1 ? '是' : '否';
            }
          },
        ],
      },
      maxHeight: 500,
      statusDuration: 120,
      statusDialogVisible: false,
      countTimer: '',
      queryLoading: false,
      billGenerateForm: {},

      billGenerateFormFlag: false,
      billPay: {},
      zhxx: {},
      bankBillStatusList: [],
      pageOption: {
        total: 0,
        size: 10,
        current: 1,
      },
      dicts: [],
      defaultPropsSubjectId: {
        children: 'children',
        label: 'name',
      },
      payScene: '',
      payManName: '',

      totalCalAmount: '',
      totalShouldAmount: '',
      totalDelayAmount: '',
      totalDerateAmount: '',
      totalAccountpayAmount: '',
      totalCouponAmount: '',

      communityName: '',
      payInfo: {
        payBillNo: '',
      },
      payInfo2: {
        timer: '',
        showQrCode: false,
        countdown: '',
        payStatus: '',
        payDetailList: [],
      },
      subjectDisabledFlag: true,
      showAuthCodeFlag: false,
      payBillList: [],
      payTypeList: [],
      paySceneList: [],
      subjectList: [],
      subjectIds: '',
      billPayForm: {},
      billPayBoxFlag: false,
      billPayData: [
        {
          date: '物业费',
          couponName: '交满1000元送大米一袋',
          address: '202010',
          shouldpay: '180',
          discount: '30',
        },
      ],
      tableData: [],
      billOweDesc: {},
      descText: '目前无欠费',
      //账单收费
      billPay2: {
        propertyAmountCheck: 1, //账单收费:物业费checkbox
        otherAmountCheck: 1, //账单收费:其他自收费checkbox
        proxyAmountCheck: 1, //账单收费:代收费checkbox
        list: [], //账单收费:全部账单列表
      },
      selectionList: [],
      // 销账
      offBillBoxFlag: false,
      offBillFormData: {},
      offBillFormOption: {
        menuBtn: false,
        labelWidth: 120,
        column: [
          {
            label: '销账金额',
            prop: 'writeOffAmount',
            disabled: true,
          },
          {
            label: '销账方式',
            prop: 'payType',
            type: 'select',
            dicUrl: '/api/propertyCharges/pay/paylist',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            rules: [{ required: true, message: '请选择销账方式', trigger: 'change' }],
          },
          {
            label: '支付日期',
            prop: 'payTime',
            type: 'date',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [{ required: true, message: '请选择支付日期', trigger: 'change', }]
          },
          {
            label: '收款人',
            prop: 'cashierName',
            disabled: true,
          },
          {
            label: '收款备注',
            prop: 'remark',
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxRows: 3,
            maxlength: 200,
            showWordLimit: true,
            rules: [{ required: true, message: '请输入收款备注', trigger: 'blur', }]
          },
        ],
      },
      // 减免
      reduceBoxFlag: false,
      reduceAmount: 0,
      reduceTableData: [],
      reduceFormData: {},
      reduceTableOption: {
        height: 'auto',
        calcHeight: 200,
        border: true,
        addBtn: false,
        menu: false,
        refreshBtn: false,
        columnBtn: false,
        showSummary: true,
        sumColumnList: [
          {
            label: ' ',
            name: 'calAmount',
            type: 'sum',
          },
          {
            label: ' ',
            name: 'shouldAmount',
            type: 'sum',
          },
          {
            label: ' ',
            name: 'reductionBeforeAmount',
            type: 'sum',
          },
          {
            label: ' ',
            name: 'reductionAmount',
            type: 'sum',
          },
        ],
        column: [
        {
            prop: 'billFeeItemName',
            label: '费用类别',
          },
          {
            prop: 'billcycleNo',
            label: '账单周期',
            width: 120,
          },
          {
            prop: 'calAmount',
            label: '理论金额',
            align: 'right',
            formatter: (row) => {
              return this.tool.money_format_allowvoid(row.calAmount)
            }
          },
          {
            prop: 'shouldAmount',
            label: '应收金额',
            align: 'right',
            formatter: (row) => {
              return this.tool.money_format_allowvoid(row.shouldAmount)
            }
          },
          {
            prop: 'reductionBeforeAmount',
            label: '减免前应收金额',
            align: 'right',
            formatter: (row) => {
              return this.tool.money_format_allowvoid(row.reductionBeforeAmount)
            }
          },
          {
            prop: 'reductionAmount',
            label: '减免金额',
            align: 'right',
            formatter: (row) => {
              return this.tool.money_format_allowvoid(row.reductionAmount)
            }
          },
          {
            prop: 'billStartDate',
            label: '账单开始时间',
            width: 120,
          },
          {
            prop: 'billEndDate',
            label: '账单结束时间',
            width: 120,
          },
        ],
      },
      reduceFormOption: {
        menuBtn: false,
        labelWidth: 120,
        column: [
          {
            label: '减免单编码',
            prop: 'reductionNo',
            span: 8,
            disabled: true,
          },
          {
            label: '减免时间',
            prop: 'reductionTime',
            span: 8,
            type: 'datetime',
            rules: [{ required: true, message: '请选择减免时间', trigger: 'change', }]
          },
          {
            label: '操作人',
            prop: 'reductionUserName',
            span: 8,
            disabled: true,
          },
          {
            label: '减免原因',
            prop: 'reductionReason',
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxRows: 3,
            maxlength: 200,
            showWordLimit: true,
            rules: [{ required: true, message: '请输入减免原因', trigger: 'blur', }]
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(['userInfo']),
    ...mapGetters(['tagList']),
    ...mapGetters(['permission']),
    permissions() {
      return {
        propertyAmountCheck: this.vaildData(
          this.permission.propertyCharge_propertyAmountCheck,
          false
        ),
        otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
        proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
        byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
        byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
        byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
        billStartDateEdit: this.vaildData(this.permission.billStartDate_edit, false),
      };
    },

    payParams() {
      let params = this._.merge(
        {
          roomId: this.zhxx.roomId,
          roomName: this.zhxx.roomName,
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.zhxx.householder,
        },
        {
          payInfo: {
            //           "billTotalAmount": 5,
            // "preTotalAmount": 0,
            // "carTotalAmount": 0,
            // "temporaryTotalAmount": 0,
            // "totalShouldAmount": 5,
            // "accountAmount": 0,
            // "totalAccountpayAmount": 0,
            // "totalPayAmount": 5,
            // this.payInfo.totalPayAmount = NP.strip(
            //     this.totalShouldAmountCP - this.payInfo.totalAccountpayAmount
            //   );
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: 0,
            carTotalAmount: 0,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalShouldAmountCP,
            totalAccountpayAmount: 0,
            totalCouponAmount: 0,
            totalPayAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify(this.payInfo2.payDetailList),
          },
        }
      );
      params.billPay = this.billPay;
      return params;
    },

    billTotalAmountCP() {
      return Number(this.totalShouldAmount);
    },
    totalShouldAmountCP() {
      return this.billTotalAmountCP;
    },
    billGenerateFormOption() {
      return {
        menuBtn: false,
        labelWidth: 110,
        column: [
          {
            label: '客户',
            prop: 'client',
            disabled: true,
            // formslot:true,
            span: 12,
          },
          {
            label: '房间',
            prop: 'roomName',
            disabled: true,
            // formslot:true,
            span: 12,
          },
          {
            label: '收费科目',
            prop: 'subjectId',
            // disabled:true,
            formslot: true,
            span: 12,
          },
          {
            label: '收费标准',
            prop: 'standard',
            disabled: true,
            rules: [
              {
                required: true,
                message: '请选择收费标准',
                trigger: 'blur',
              },
            ],
            // formslot:true,
            span: 12,
          },
          {
            label: '数量',
            prop: 'floorage',
            disabled: true,
            // formslot:true,
            span: 12,
          },
          {
            label: '开始时间',
            prop: 'startTime',
            type: 'date',
            disabled: !this.permissions.billStartDateEdit,
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            // disabled:true,
            // formslot:true,
            span: 12,
          },
          {
            label: '期数',
            prop: 'cycle',
            rules: [
              {
                required: true,
                message: '请选择期数',
                trigger: 'blur',
              },
            ],
            // disabled:true,
            // maxlength:3,
            formslot: true,
            span: 12,
          },
          {
            label: '结束时间',
            prop: 'endTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            disabled: true,
            rules: [
              {
                required: true,
                message: '请先选择开始时间和期数',
                trigger: 'change',
              },
            ],
            // formslot:true,
            span: 12,
          },
          {
            label: '开账截止时间',
            prop: 'billEndTime',
            type: 'datetime',
            disabled: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 140,
            span: 24,
            rules: [
              {
                required: true,
                message: '请通知相关人员在【小区管理】模块设置开账截止时间！',
                trigger: 'change',
              },
            ],
          },
        ],
      };
    },

    billPayFormOption() {
      return {
        menuBtn: false,
        column: [
          {
            label: '押金抵扣',
            prop: 'depositId',
            formslot: true,
            span: 12,
          },
          {
            label: '押金金额',
            prop: 'depositAmount',
            disabled: true,
            span: 12,
          },
          {
            label: '优惠券',
            prop: 'couponCode',
            formslot: true,
            span: 12,
          },
          {
            label: '优惠金额',
            prop: 'couponAmount',
            disabled: true,
            span: 12,
          },
          {
            label: '收款方式',
            prop: 'payType',
            formslot: true,
            span: 12,
            maxlength: 3,
            rules: [
              {
                required: true,
                message: '请选择收款方式',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收款类型',
            prop: 'payScene',
            formslot: true,
            span: 12,
            maxlength: 3,
            rules: [
              {
                required: true,
                message: '请选择收款类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '付款码',
            prop: 'authCode',
            formslot: true,
            display: false,
            span: 12,
            maxlength: 3,
            rules: [
              {
                required: true,
                message: '请输入付款码',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收款备注',
            prop: 'description',
            span: 24,
            type: 'textarea',
          },
        ],
      };
    },
  },
  created() {
    // this.loadDicts();
    this.getBankBillStatus();
  },
  // watch:{
  //   tableData(val){
  //     console.log('tableData Change!=================>',val);

  //     console.log('tableData Change!=================>',this.tableData);
  //     this.page.total = val.length;
  //     this.page.current = 1;
  //   }
  // },
  updated() {
    if (this.$refs.avueCrud.table) {
      console.log('updated!!!===============>', this.$refs.avueCrud.doLayout);
      console.log('updated!!!===============>', this.$refs.avueCrud.table);
      this.$refs.avueCrud.doLayout();
      this.$refs.avueCrud.$refs.table.doLayout();
    }
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.avueCrud.refreshTable();
    });
  },
  mounted() {
    // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
    setTimeout(() => {
      window.onresize = () => {
        this.$nextTick(() => {
          this.$refs.avueCrud.refreshTable();
        });
      };
    });

    let windowHeight = document.body.clientHeight;
    this.maxHeight = windowHeight - 430;
    this.option.height = this.maxHeight;
    // maxHeight
    //根据按钮权限改变费项值
    this.billPay2.propertyAmountCheck = this.permissions.propertyAmountCheck ? 1 : 0;
    this.billPay2.otherAmountCheck = this.permissions.otherAmountCheck ? 1 : 0;
    this.billPay2.proxyAmountCheck = this.permissions.proxyAmountCheck ? 1 : 0;
    const node_ = document.createElement('span');
    console.log('node_============>', node_);
    node_.classNmae = 'sumAmount';
    // const textnode_ = document.createTextNode("应收合计 0 元");
    const textnode_ =
      "<span>应收合计 <span class='avue-crud__tip-count' id='sumAmount'>0</span> 元</span>";
    node_.innerHTML = textnode_;
    let elTag = document.querySelector('#fee20211117').querySelector('.avue-crud__tip-name');
    elTag.appendChild(node_);

    let parentBox = document.querySelector('#fee20211117').querySelector('.avue-crud');
    let subjectItemBox = document.querySelector('#fee20211117').querySelector('.feeItemSelectBox');
    let elTagTip = document
      .querySelector('#fee20211117')
      .querySelector('.avue-crud')
      .querySelector('.el-form');

    parentBox.insertBefore(subjectItemBox, elTagTip);
    console.log('avue-crud__tip-name===============>');
  },
  methods: {
    /* 选择押金种类 */
    updateDepositObj(item) {
      this.billPayForm.depositId = item.id;
      this.billPayForm.depositAmount = item.depositAmount;
      this.depositName = item.defItemset;
    },
    /* 清除押金信息 */
    clearDeposit() {
      this.billPayForm.depositId = '';
      this.billPayForm.depositAmount = '';
      this.depositName = '';
    },
    refreshHandler() {
      this.loadBillList(this.targetId, '', this.subjectIds);
    },
    resetTableStyle() {
      console.log(212121);
      setTimeout(() => {
        this.$refs.avueCrud.doLayout();
        this.$refs.avueCrud.$refs.table.doLayout();
      });
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    queryCouponCode() {
      if (!this.billPayForm.couponCode) {
        this.$message.error('请输入优惠券');
        return;
      }
      this.queryLoading = true;
      if (this.billPayForm.couponAmount)
        this.totalShouldAmount = (
          parseFloat(this.totalShouldAmount) + parseFloat(this.billPayForm.couponAmount)
        ).toFixed(2);
      this.billPayForm.couponAmount = 0;
      queryCouponCode({
        roomId: this.targetId,
        code: this.billPayForm.couponCode,
        billShouldAmount: this.totalShouldAmount,
      })
        .then((res) => {
          this.queryLoading = false;
          this.billPayForm.couponAmount = res.data;
          this.totalShouldAmount = (
            parseFloat(this.totalShouldAmount) - parseFloat(this.billPayForm.couponAmount)
          ).toFixed(2);
        })
        .catch((res) => {
          this.queryLoading = false;
        });
    },
    cancelBillCreate() {
      this.billGenerateFormFlag = false;
    },
    submitBillCreate() {
      if (!this.submitBillLoadingFlag) {
        this.submitBillLoadingFlag = true;
        //  return;
      } else {
        return;
      }
      let self = this;
      // 比较开账结束时间是否大于设置的开账截止时间
      if (
        Date.parse(self.billGenerateForm.endTime) > Date.parse(self.billGenerateForm.billEndTime)
      ) {
        this.$message.error('开账结束时间请不要大于开账截止时间！');
        return;
      }
      this.$refs.billGenerateForm.validate((valid) => {
        if (valid) {
          generateFeeBill({
            roomId: self.targetId,
            itemsetId: self.billGenerateForm.itemsetId,
            billcycleNo: self.billGenerateForm.startTime.replace('-', ''),
            cycleNum: self.billGenerateForm.cycle,
            billEndTime: self.billGenerateForm.billEndTime,
          })
            .then((res) => {
              self.$message.success('操作成功!');
              self.billGenerateFormFlag = false;
              console.log(res);
              self.loadBillList(self.targetId);

              self.submitBillLoadingFlag = false;
            })
            .catch((err) => {
              self.submitBillLoadingFlag = false;
            });
        } else {
          self.submitBillLoadingFlag = false;
        }
      });
    },
    cycleBlur(e) {
      console.log('cycleBlur=====>', e);
      let val = e.target.value;
      if (!val) {
        this.$message.error('请填写期数！');
        return;
      }
      if (!this.billGenerateForm.startTime) {
        this.$message.error('请选择账单开始时间！');
        return;
      }
      let billcycleNo = this.billGenerateForm.startTime.replace('-', '');
      let itemsetId = this.billGenerateForm.itemsetId;
      getGenerateEnddate({ billcycleNo: billcycleNo, cycleNum: val, itemsetId: itemsetId }).then(
        (res) => {
          console.log(res);
          this.billGenerateForm.endTime = res.data.split(' ')[0];
        }
      );
    },
    cycleInput(val) {
      // if(!val){
      //     this.$message.error('请填写期数！');
      //     return;
      // }
      // if(!this.billGenerateForm.startTime){
      //     this.$message.error('请选择账单开始时间！');
      //     return;
      // }
      // let billcycleNo = this.billGenerateForm.startTime.replace('-','');
      // let itemsetId = this.billGenerateForm.itemsetId;
      // getGenerateEnddate({billcycleNo:billcycleNo,cycleNum:val,itemsetId:itemsetId}).then((res)=>{
      //   console.log(res);
      //   this.billGenerateForm.endTime = res.data.split(' ')[0];
      // });
    },
    //查询预收费金额
    billGenerateSubjectIdChange(val) {
      console.log('billGenerateSubjectIdChange=========>', val);
      getGenerateItemsetList({ roomId: this.targetId, feeSort: val }).then((res) => {
        console.log(res);
        this.billGenerateForm.standard = res.data.advanceFeeItemName;
        this.billGenerateForm.itemsetId = res.data.itemsetId;
        this.billGenerateForm.startTime = res.data.billCycleNoStart;
      });
    },
    //查询缴费人员id和缴费账户余额
    queryAccountAmount() {
      loadAccountAmount({ roomId: this.targetId }).then(({ data }) => {
        this.payManId = data.payManId;
        this.payInfo.accountAmount = data.accountAmount || 0;
      });
    },
    //查询住户信息
    queryZhxx(params) {
      loadZhxx(params).then(({ data }) => {
        this.zhxx.floorage = data[0].floorage;
        this.zhxx.billEndTime = data[0].billEndTime;
      });
    },
    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        // const element = feeBillList[index];
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      // feeBillList.forEach((v,i)=>{
      //   console.log(v,i);
      // });
      return { isLock, index_: index_ };
    },
    //选中
    confirmBillPay() {
      this.payInfo2.payDetailList = [];
      // this.payInfo.authCode
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.payBillList)) {
        this.$message.warning('请选择账单');
        return;
      }

      let arrayLength = this.payBillList.length;
      // this.billPay.feeBillList.push(this.billPay.feeBillList[arrayLength-1]);
      // this.billPay.feeBillList[arrayLength-1].lockFlag = 1;
      console.log(this.payBillList);
      console.log(this.isPayBillLock(this.payBillList));

      let isLockedObject = this.isPayBillLock(this.payBillList);
      let self = this;

      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.payBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      let sumAmount = 0;
      let sumCalAmount = 0;
      let sumDerateAmount = 0;
      let sumDelayAmount = 0;
      let sumCouponAmount = 0;
      let sumAccountpayAmount = 0;
      this.payBillList;
      // this.billPay.sumOfAmount = NP.strip(this._.sumBy(selection, 'billShouldAmount'));
      this.payBillList.forEach((element) => {
        sumAmount = parseFloat(sumAmount) + parseFloat(element.billShouldAmount);
        sumCalAmount = parseFloat(sumCalAmount) + parseFloat(element.calAmount);
        sumDelayAmount = parseFloat(sumDelayAmount) + parseFloat(element.delayAmount);
        sumCouponAmount = parseFloat(sumCouponAmount) + parseFloat(element.billCouponAmount);
        sumDerateAmount = parseFloat(sumDerateAmount) + parseFloat(element.billPreferentAmount);
        sumAccountpayAmount =
          parseFloat(sumAccountpayAmount) + parseFloat(element.accountpayAmount);
      });
      this.totalShouldAmount = sumAmount.toFixed(2);
      this.totalCalAmount = sumCalAmount.toFixed(2);
      this.totalDerateAmount = sumDerateAmount.toFixed(2);
      this.totalDelayAmount = sumDelayAmount.toFixed(2);
      this.totalCouponAmount = sumCouponAmount.toFixed(2);
      this.totalAccountpayAmount = sumAccountpayAmount.toFixed(2);

      this.billPay.derateAmount = sumDerateAmount.toFixed(2);
      // return;
      //   this.selected.billPay = true;
      this._.forEach(self.payBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'billPay',
          feeName: item.billFeeItemName,
          feePeriod:
            dayjs(item.billStartDate).format('YYYY-MM-DD') +
            ' - ' +
            dayjs(item.billEndDate).format('YYYY-MM-DD'),
          calAmount: item.calAmount + '',
          delayAmount: item.delayAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          accountpayAmount: item.accountpayAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
      this.openBillPayBox();
    },
    //查询账单明细
    queryBill() {
      loadBill(
        {
          roomId: this.targetId,
          propertyAmountCheck: this.billPay2.propertyAmountCheck,
          otherAmountCheck: this.billPay2.otherAmountCheck,
          proxyAmountCheck: this.billPay2.proxyAmountCheck,
        },
        { showLoading: { text: '查询中' } }
      ).then(({ data }) => {
        this.billPay2.list = data.feeBillList;
      });
    },
    //修改账单明细优惠
    updateBill(row) {
      if (!/^([0-9]+(\.[0-9]{1,2})?)$/.test(row.billCouponAmount)) {
        this.$message.error('格式错误');
        return;
      }
      if (row.billCouponAmount > row.calAmount) {
        this.$message.error('不能超过理论金额');
        return;
      }
      updateBill(
        { billId: row.billId, billCouponAmount: row.billCouponAmount },
        { showLoading: { text: '更新账单明细' } }
      ).then(() => {
        this.queryBill();
      });
    },
    getBankBillStatus() {
      bankBillStatus().then((res) => {
        this.bankBillStatusList = res.data;
        console.log(res);
      });
    },
    getLockFlagStatus(lockFlag) {
      // if(parseInt(lockFlag)==0){
      //   return '未锁定';
      // }
      // if(parseInt(lockFlag)==1){
      //   return '划扣中';
      // }
      let lockFlagLabel = '';
      this.bankBillStatusList.forEach((v, i) => {
        if (parseInt(v.dictKey) == lockFlag) {
          lockFlagLabel = v.dictValue;
        }
      });
      return lockFlagLabel;
    },
    //打印预览
    printprev() {
      this.$confirm('收费成功，是否需要打印收据？', '提示', {
        confirmButtonText: '打印',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          if (
            this.payInfo.payBillNo != ''
            // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
          ) {
            this.billPayBoxFlag = false;
            this.$refs.billPayForm.resetForm();
            this.loadBillList(this.targetId, '', '');
            this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
          } else {
            this.$message.warning('请先完成收款');
          }
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
          //重置数据
          this.billPayBoxFlag = false;
          this.$refs.billPayForm.resetForm();
          this.loadBillList(this.targetId, '', '');
          // this.resetAllData();
        });
    },
    openTag(item) {
      let tag;
      if (item.name) {
        tag = this.findTag(item.name).tag;
      } else {
        tag = item;
      }
      if (tag.query.src === undefined || tag.query.src === 'undefined') {
        tag.query = {};
      }
      this.$router.push({
        path: this.$router.$avueRouter.getPath(
          {
            name: tag.label,
            src: tag.value,
          },
          tag.meta
        ),
        query: tag.query,
      });
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    blurHandler() {
      console.log();
      this.$refs.authCodeInput;
      this.billPayForm.authCode;
      //   this.billPayForm = Object.assign({},this.billPayForm,{authCode:''});
    },
    focusHandler() {
      console.log();
      this.$refs.authCodeInput;
      this.billPayForm.authCode;
      this.billPayForm = Object.assign({}, this.billPayForm, { authCode: '' });
    },
    inputHandler(val) {
      this.$refs.authCodeInput;
      this.billPayForm.authCode;
      //   this.billPayForm = Object.assign({},this.billPayForm,{authCode:''});
    },
    couponNameChange(val) {
      console.log(this.billPayData);
    },
    findDictValue(dictKey, dictData) {
      let res;
      if (!dictKey || !dictData || dictData.length == 0) {
        console.log('emoty==>');
        return '';
      }
      dictData.forEach((item) => {
        if (item.dictKey == dictKey) {
          res = item;
        }
      });
      return res.dictValue || '';
    },
    loadDicts() {
      //圆整方式,计费方式,定价模式,支付周期,周期单位,账单生成颗粒,违约金起算日期(应收日期),收费精度,算费费率单位,不足月计算方式,不足月天数定义,收费仪表大类,收费仪表小类
      const dictCodes = [
        'fee_standard_round_way',
        'fee_standard_cal_way',
        'fee_standard_pricing_model',
        'fee_standard_cycle_start_rule',
        'fee_standard_cycle_type',
        'fee_standard_cycle_unit',
        'fee_standard_bill_generate_rule',
        'fee_standard_delay_start_type',
        'fee_standard_precision',
        'fee_standard_unit',
        'fee_standard_less_month_way',
        'fee_standard_less_month_days_way',
        'fee_standard_meter_big',
        'fee_standard_meter_big_small',
      ];
      let promises = [];
      dictCodes.forEach((item) => {
        promises.push(getDict({ code: item }));
      });
      Promise.all(promises).then((resArr) => {
        let dicts = {};
        resArr.forEach((item, index) => {
          let key = dictCodes[index];
          dicts[key] = item.data;
        });
        this.dicts = dicts;
        // this.disableAddBtn = false;
        console.log('this.dicts==>', this.dicts);
      });
    },
    handleShowPrice(item) {
      try {
        let res = '';
        if (item.feeWay == '1') {
          res +=
            item.feePrice +
            '元 / m² .' +
            this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
        } else if (item.feeWay == '2') {
          // res +=
          //   item.feePrice + '元 .' + this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
        } else if (item.feeWay == '3') {
          if (item.pricingModel == '1') {
            res +=
              item.feePrice +
              '元 / ' +
              this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
          } else {
            res = '';
          }
        } else if (item.feeWay == '99') {
          if (item.pricingModel == '1') {
            res +=
              item.feePrice +
              '元 / ' +
              this.findDictValue(item.feeUnit, this.dicts.fee_standard_unit);
          } else {
            res = '';
          }
        }
        return res;
      } catch (err) {
        console.log('handleShowPrice err==>', err);
        return '';
      }
    },
    getSubjectListHandler() {
      // getSubjectList().then((res)=>{
      getDict({ code: 'fee_item_type' }).then((res) => {
        console.log(res);
        this.subjectList = res.data;
        // this.subjectList.unshift({id:'',name:'全部'});
        console.log(this.subjectList);
        this.subjectIds = [this.subjectList[3].dictKey];
      });
    },
    subjectDisabled() {
      this.subjectDisabledFlag = true;
      this.tableData = [];
      this.billOweDesc = {};
      this.zhxx.householder = '';
      this.zhxx.linkPhone = '';
      this.page.total = 0;
      this.page.current = 1;
      this.handelDescText();
    },
    subjectActive() {
      this.subjectDisabledFlag = false;
    },
    confirmPayAction() {
      console.log('this.payParams=====>', this.payParams);
      // return;
      this.genearateQrCode();
    },
    getCollectBillList() {
      let tempArr = [];
      let targetId = this.targetId;
      this.subjectList.forEach((ele_, index_) => {
        let billCycleNoArr = [];
        let shouldPayAmount = 0.0;
        this.payBillList.forEach((ele, index) => {
          if (ele_.id === ele.subjectId) {
            billCycleNoArr.push(ele.billcycleNo);
            shouldPayAmount = parseFloat(shouldPayAmount) + parseFloat(ele.billAmount);
          }
        });
      });
      console.log('tempArr=====>', tempArr);
      this.billPayData = tempArr;
    },
    getBillFormData() {
      let self = this;
      console.log(this.payBillList);
      this.payScene = this.billPayForm.payScene;
      let payScene = this.payScene;
      let payType = this.billPayForm.payType;
      let authCode = this.billPayForm.authCode;

      let payList = [];
      let communityId = '';
      let targetId = '';
      let totalCalAmount = 0;
      let payManName = '';
      this.payBillList.forEach((ele, index) => {
        communityId = ele.communityId;
        targetId = ele.targetId;
        payManName = ele.ownerName;
        totalCalAmount = parseFloat(totalCalAmount) + parseFloat(ele.billAmount);
        payList.push({
          subjectId: ele.subjectId,
          standardId: ele.standardId,
          linkId: ele.id,
          calAmount: ele.billAmount,
          shouldAmount: ele.billAmount,
          isDiscount: '0',
          billcycleNo: ele.billcycleNo,
          description: 'description',
        });
      });

      totalCalAmount = Math.round(totalCalAmount * 100) / 100;
      this.payParams = {
        authCode: authCode,
        communityId: communityId,
        payScene: payScene,
        payType: payType,
        totalCalAmount: totalCalAmount,
        totalShouldAmount: totalCalAmount,
        payManName: payManName,
        targetId: targetId,
        resourceType: 1,
        pay_cost: 1,
        payList: payList,
      };
      console.log(this.payParams);
    },
    //生成二维码
    genearateQrCode() {
      this.$refs.billPayForm.validate((valid) => {
        if (valid) {
          if (!this.paySubmitBtn) {
            return;
          }
          this.paySubmitBtn = false;
          this.payParams.totalShouldAmount = this.totalShouldAmount;
          this.payParams.totalAccountpayAmount = this.totalAccountpayAmount;
          this.payParams.totalCouponAmount = parseFloat(this.totalCouponAmount || 0) + parseFloat(this.billPayForm.couponAmount || 0) + '';
          this.payParams.totalDerateAmount = this.totalDerateAmount;
          this.payParams.totalDelayAmount = this.totalDelayAmount;
          this.payParams.totalCalAmount = this.totalCalAmount;

          this.payParams.payScene = this.billPayForm.payScene;
          this.payParams.payType = this.billPayForm.payType;
          this.payParams.payManName = this.zhxx.householder;
          this.payParams.payManId = this.payManId;
          this.payParams.payCost = '11';
          this.payParams.roomName = this.communityName;
          this.payParams.propertyId = this.targetId;
          this.payParams.authCode = this.billPayForm.authCode;
          this.payParams.couponCode = this.billPayForm.couponCode;
          this.payParams.description = this.billPayForm.description;
          this.payParams.depositId = this.billPayForm.depositId || '';
          this.payParams.depositAmount = this.billPayForm.depositAmount || 0;

          this.payParams.billList = this.payBillList;

          console.log('this.payParams=====>', this.payParams);
          if (parseInt(this.billPayForm.payScene) == 5) {
            this.qrCodePay();
          } else if (parseInt(this.billPayForm.payScene) == 6) {
            this.authCodePay();
          } else {
            this.paySubmitBtn = true;
            this.normalPay();
          }
        }
      });
    },
    qrCodePay() {
      billPayNewSubmit(this.payParams, { showLoading: { text: '正在获取二维码' } })
        .then(({ data }) => {
          this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.$nextTick(() => {
            new QRCode('qrcode', {
              width: 250,
              height: 250,
              text: data.qrCodeUrl,
            });
          });
          this.payInfo2.showQrCode = true;
          this.payInfo2.countdown = 120;
          this.paySubmitBtn = true;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，二维码弹窗关闭');

              this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                confirmButtonText: '更新账单',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  // this.$message({
                  //     type: 'success',
                  //     message: '删除成功!'
                  // });
                  // this.printprev()
                  this.billPayBoxFlag = false;
                  let { tag, key } = this.findTag('/v4ward/payrecord/payErrorquery');
                  this.$store.commit('DEL_TAG', tag);
                  this.$router.push({ path: `/v4ward/payrecord/payErrorquery` });
                })
                .catch(() => {
                  // this.$message({
                  //     type: 'info',
                  //     message: '已取消删除'
                  // });
                  //重置数据
                  this.resetAllData();
                });

              // this.resetAllData();
              // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});
            }
            if (this.payInfo2.countdown % 5 === 0) {
              loadPayStatusPlatformV1({ paybillNo: this.payInfo.payBillNo }).then(({ data }) => {
                this.payInfo2.payStatus = data.payStatus;
                if (parseInt(data.payStatus) == 1) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  this.printprev();

                  // this.$confirm('收费成功，是否需要打印收据？', '提示', {
                  //     confirmButtonText: '打印',
                  //     cancelButtonText: '取消',
                  //     type: 'warning'
                  // }).then(() => {
                  //     // this.$message({
                  //     //     type: 'success',
                  //     //     message: '删除成功!'
                  //     // });
                  //     this.printprev()
                  // }).catch(() => {
                  //     // this.$message({
                  //     //     type: 'info',
                  //     //     message: '已取消删除'
                  //     // });
                  //     //重置数据
                  //     this.resetAllData();
                  // });
                  // this.submitAllBill();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        })
        .catch((err) => {
          this.paySubmitBtn = true;
        });
    },
    authCodePay() {
      billPayNewSubmit(this.payParams, { showLoading: { text: '正在获取二维码' } })
        .then(({ data }) => {
          // this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.isSuccess = true;
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          console.log('data==>', data);
          // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
          // this.openMaskAndPollingPayStatus(data.paybillNo);
          // return;
          if (data.paybillNo) {
            this.openMaskAndPollingPayStatus(data.paybillNo);
            this.paySubmitBtn = true;
          } else {
            this.paySubmitBtn = true;
            // 可以打印
            this.printprev();
            this.payInfo2.payStatus = 1;
          }
          // fix end
          // this.submitAllBill();
          //清楚数据
          // this.resetAllData();
        })
        .catch((err) => {
          this.paySubmitBtn = true;
        });
    },

    normalPay() {
      this.submitAllBill();
      // saveQrCodePay_(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
      //     ({ data }) => {
      //     this.payInfo.payBillNo = data.payBillNo;
      //         loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
      //             this.payInfo2.tradeStatus = data.payStatus;
      //             if (parseInt(data.payStatus) == 1) {
      //             this.$message.success('支付成功');
      //             //重置数据
      //             this.resetAllData();
      //             // this.submitAllBill();
      //             }
      //         });
      //     }
      // );
    },

    openMaskAndPollingPayStatus(paybillNo) {
      this.statusDialogVisible = true;
      this.countTimer = setInterval(() => {
        console.log('this.status==>', this.statusDuration);
        this.statusDuration--;
        console.log('this.status==>', typeof this.statusDuration);
        if (this.statusDuration <= 0) {
          this.$message.error('支付失败');
          this.statusDialogVisible = false;
          clearInterval(this.countTimer);
          this.statusDuration = 120;
          window.location.reload();

          // clearInterval(this.payInfo2.timer);
          // this.payInfo2.showQrCode = false;
          // this.$message.info('倒计时结束，二维码弹窗关闭');

          this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
            confirmButtonText: '更新账单',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // this.$message({
              //     type: 'success',
              //     message: '删除成功!'
              // });
              // this.printprev()
              let { tag, key } = this.findTag('/v4ward/payrecord/payErrorquery');
              this.$store.commit('DEL_TAG', tag);
              this.$router.push({ path: `/v4ward/payrecord/payErrorquery` });
              this.billPayBoxFlag = false;
            })
            .catch(() => {
              // this.$message({
              //     type: 'info',
              //     message: '已取消删除'
              // });
              //重置数据
              this.resetAllData();
            });
        } else {
          if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
            loadPayStatusChannelV1({ paybillNo: paybillNo }).then(({ data }) => {
              console.log('res pooling  data==>', data);

              if (parseInt(data.payStatus) == 1) {
                this.payInfo2.payStatus = data.payStatus;
                this.$message.success('支付成功');
                // 可以打印
                this.printprev();
                this.statusDialogVisible = false;
                clearInterval(this.countTimer);
                this.statusDuration = 120;
              }
            });
          }
        }
      }, 1000);
    },
    //保存账单
    submitAllBill() {
      billPayNewSubmit(this.payParams, { showLoading: { text: '处理中' } })
        .then(({ data, msg }) => {
          this.paySubmitBtn = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.isSuccess = data.isSuccess;
          this.$message.success(msg);
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          // 可以打印
          this.printprev();
          //清楚数据
          // this.resetAllData();
        })
        .catch((err) => {
          this.paySubmitBtn = true;
        });
    },
    //关闭二维码
    closeQrCode_() {
      clearInterval(this.countTimer);
    },
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
    },
    resetAllData() {
      location.reload();
    },
    payTypeChange(val) {
      if (val) {
        this.billPayForm.payScene = '';
        let columns = this.$refs.billPayForm.columnOption[0].column;
        if (parseInt(val) == 1 || parseInt(val) == 8 || parseInt(val) == 11) {
          this.findObject(columns, 'authCode').display = false;
          this.showAuthCodeFlag = false;
          this.findObject(columns, 'payScene').display = false;
        } else {
          this.showAuthCodeFlag = true;
          this.findObject(columns, 'payScene').display = true;
        }
        getPaySceneListNew({ payType: val }).then((res) => {
          this.paySceneList = res.data;
          console.log(res);
        });
      }
    },
    paySceneChange(val) {
      console.log(this.$refs.billPayForm);
      let columns = this.$refs.billPayForm.columnOption[0].column;
      if (parseInt(val) == 6) {
        this.showAuthCodeFlag = true;
        this.findObject(columns, 'authCode').display = true;
      } else {
        this.showAuthCodeFlag = false;
        this.findObject(columns, 'authCode').display = false;
      }
    },
    subjectIdChange(val) {
      console.log(val);
      if (!val || val.length < 1) {
        val = ['99'];
      }
      let self = this;
      if (val && val.length > 1) {
        console.log('subjectIdChange=====>', val);
        val.forEach((ele, index) => {
          if (ele === '99') {
            self.subjectIds.splice(index, 1);
          }
        });
      }
      this.pageOption.current = 1;
      this.loadBillList(this.targetId, '', val);
      console.log('subjectIdChange=========>', val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageOption.size = val;
      this.loadBillList(this.targetId, '', val);
    },
    handleCurrentChange(val) {
      this.pageOption.current = val;
      console.log(`当前页: ${val}`);
      this.loadBillList(this.targetId, '', val);
    },
    loadBillList(targetId, targetName, subjectIds, householderName, householderPhone, floorAge, fullName) {
      if (!subjectIds) {
        subjectIds = [99];
      }
      this.targetId = targetId;
      if (householderName) {
        this.zhxx.householder = householderName;
        this.zhxx.linkPhone = householderPhone;
      }
      if (targetName) {
        this.communityName = targetName;
      }
      this.zhxx.floorAge = floorAge || '';
      this.zhxx.fullName = fullName || targetName || '';
      let subjectIds_ = [];
      if (subjectIds && subjectIds.length > 0) {
        subjectIds_ = subjectIds.join(',');
      } else {
        // subjectIds_ = this.subjectIds.join(',');
        subjectIds_ = subjectIds.join(',');
      }
      console.log('subjectIds_====>', subjectIds_);
      getFeeBillList({
        roomId: this.targetId,
        feeItems: subjectIds_,
      }).then(({ data }) => {
        console.log('this.zhxx.householder========>', this.zhxx.householder);
        console.log(data);
        data.forEach((ele) => {
          ele.billStartDate = dayjs(ele.billStartDate).format('YYYY-MM-DD');
          ele.billEndDate = dayjs(ele.billEndDate).format('YYYY-MM-DD');
        });
        this.tableData = data;
        this.page.total = data.length;
        this.page.current = 1;
        this.getBillOweDescHandler();
      });
    },
    getBillOweDescHandler() {
      getFeeBillOweDesc({
        roomId: this.targetId,
      }).then((res) => {
        console.log('getFeeBillOweDesc=======================>', res.data);
        this.billOweDesc = res.data;
        this.handelDescText();
      });
    },
    handelDescText() {
      if (this.billOweDesc.billCycleNo == 0 && this.billOweDesc.oweNum) {
        this.descText =
          '   无缴费记录' +
          '，目前欠费' +
          (this.billOweDesc.oweNum || '0') +
          '期，合计 ' +
          (this.billOweDesc.oweMoney || '0') +
          '元';
      } else if (this.billOweDesc.billCycleNo > 0 && this.billOweDesc.oweNum) {
        this.descText =
          '   物业费缴至' +
          (this.billOweDesc.billCycleNo || '0') +
          '，目前欠费' +
          (this.billOweDesc.oweNum || '0') +
          '期，合计 ' +
          (this.billOweDesc.oweMoney || '0') +
          '元';
      } else if (this.billOweDesc.billCycleNo > 0 && !this.billOweDesc.oweNum) {
        this.descText =
          '   无缴费记录' +
          '，目前欠费' +
          (this.billOweDesc.oweNum || '0') +
          '期，合计 ' +
          (this.billOweDesc.oweMoney || '0') +
          '元';
      } else if (this.billOweDesc.billCycleNo == 0 && !this.billOweDesc.oweNum) {
        this.descText = '目前无欠费';
      } else {
        this.descText = '目前无欠费';
      }
    },
    cancelPay() {
      this.billPayBoxFlag = false;
    },
    openBillPayBox() {
      this.billPayBoxFlag = true;
    },
    billPay_() {
      if (this.payBillList.length == 0) {
        this.$message.error('请先选择账单!');
        return;
      }
      this.billToast = '';
      this.billPayForm = {};
      this.depositName = '';
      let arrIds = [];
      this.payBillList.forEach((element) => {
        arrIds.push(element.billId);
      });
      let billIds = arrIds.join(',');
      getBillPayCalculateList({ billIds: billIds, roomId: this.targetId }).then((res) => {
        console.log(res);
        this.payBillList = res.data;
        if (this.payBillList.length == 1) {
          this.billToast = '缴费账单周期：' + this.payBillList[0].billcycleNo + ',共1期';
        } else if (this.payBillList.length > 1) {
          let dateList = [];
          this.payBillList.forEach((ele) => {
            dateList.push(Number(ele.billcycleNo));
          });
          dateList.sort();
          this.billToast =
            '缴费账单周期：' +
            dateList[0] +
            '-' +
            dateList[dateList.length - 1] +
            ',共' +
            dateList.length +
            '期';
          console.log('----------');
          console.log(dateList);
        }
        this.confirmBillPay();
        this.queryZhxx({ roomId: this.targetId });
        getPayTypeList().then((res) => {
          console.log(res);
          this.payTypeList = res.data;
        });
      });
    },
    createBill() {
      console.log('createBill====');
      if (!this.targetId) {
        this.$message.error('请选择房号!');
        return;
      }
      console.log('throttle');

      loadZhxx({ roomId: this.targetId }).then(({ data }) => {
        this.billGenerateForm = {};
        this.zhxx.floorage = data[0].floorage;
        this.zhxx.billEndTime = data[0].billEndTime;
        this.billGenerateFormFlag = true;
        this.billGenerateForm.client = this.zhxx.householder;
        this.billGenerateForm.roomName = this.communityName;
        this.billGenerateForm.floorage = this.zhxx.floorage;
        this.billGenerateForm.billEndTime = this.zhxx.billEndTime;
      });
    },
    reduceTableCellStyle({ column }) {
      if (column.property == 'reductionAmount') {
        return {
          color: 'red',
        };
      }
    },
    reduceFee() {
      if (this.selectionList.length == 0) {
        this.$message.error('请先选择账单!');
        return;
      }
      const hasReduce = this.selectionList.some((ele) => {
        return ele.reductionFlag == 1;
      })
      if (hasReduce) {
        this.$message.error('请选择未减免的账单记录进行减免！');
        return;
      }
      this.reduceAmount = 0;
      this.reduceTableData = deepClone(this.selectionList);
      this.reduceTableData.forEach((ele) => {
        ele._calAmount = ele.calAmount;
        ele._billShouldAmount = ele.billShouldAmount;
        ele.shouldAmount = ele.billShouldAmount;
        ele.reductionBeforeAmount = ele.billShouldAmount;
        ele.reductionAmount = 0.00;
        ele.billListId = ele.billId;
      });
      this.reduceFormData = {
        reductionTime: this.dayjs().format('YYYY-MM-DD HH:mm:ss'),
        reductionUser: this.userInfo.user_id,
        reductionUserName: this.userInfo.nick_name,
      }
      getBusinessNo({ prefix: 'JM' }).then((res) => {
        this.reduceFormData.reductionNo = res.data;
      })
      this.reduceBoxFlag = true;
    },
    applyReduce() {
      if (this.reduceAmount <= 0) {
        this.$message.error('请先输入减免总金额！');
        return;
      }
      let rate = this.reduceAmount / this.totalShouldAmount;
      let realReduceAmount = this.reduceAmount;
      if (rate > 1) {
        rate = 1;
        realReduceAmount = this.totalShouldAmount;
      }
      let sum = 0;
      const max = this.reduceTableData.length - 1;
      this.reduceTableData.forEach((ele, index) => {
        // 最后一条数据用差值计算，免得用比例计算出现总和不一致问题
        if (index === max) {
          ele.reductionAmount = realReduceAmount - sum;
        } else {
          ele.reductionAmount = Math.round(ele.reductionBeforeAmount * rate * 100) / 100;
        }
        sum += ele.reductionAmount;
        ele.calAmount = ele._calAmount - ele.reductionAmount;
        ele.shouldAmount = ele._billShouldAmount - ele.reductionAmount;
      });
    },
    doReduce() {
      if (this.reduceAmount <= 0) {
        this.$message.error('请先输入减免总金额！');
        return;
      }
      const flag = this.reduceTableData.some((ele) => {
        return ele.reductionAmount <= 0;
      })
      if (flag) {
        this.$message.error('请先应用减免总金额！');
        return;
      }
      this.$refs.reduceForm.validate((valid) => {
        if (valid) {
          this.$refs.reduceForm.allDisabled = false;
          const params = {
            feeBillReductions: this.reduceTableData,
            reductionUser: this.reduceFormData.reductionUser,
            reductionReason: this.reduceFormData.reductionReason,
            reductionTotal: this.reduceAmount,
            flag: this.reduceAmount >= this.shouldAmount ? 1 : 0, 
          }
          reductionApi(params).then(() => {
            this.$message.success('操作成功!');
            this.reduceBoxFlag = false;
            this.loadBillList(this.targetId);
          })
          
        }
      });
    },
    doCancel(flag) {
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => { 
        if (flag === 'reduce') {
          this.reduceBoxFlag = false; 
        } else if (flag === 'offBill') {
          this.offBillBoxFlag = false;
        }
      });
    },
    offBill() {
      if (this.selectionList.length == 0) {
        this.$message.error('请先选择账单!');
        return;
      }
      this.offBillFormData = {
        writeOffAmount: this.totalShouldAmount,
        cashier: this.userInfo.user_id,
        cashierName: this.userInfo.nick_name,
      }
      this.offBillBoxFlag = true;
    },
    doOffBill() {
      this.$refs.offBillForm.validate((valid) => {
        if (valid) {
          this.$refs.offBillForm.allDisabled = false;
          const params = Object.assign({}, this.offBillFormData, { freeBillIds: this.selectionList.map(ele => ele.billId) });
          offBillApi(params).then(() => {
            this.$message.success('操作成功!');
            this.offBillBoxFlag = false;
            this.loadBillList(this.targetId);
          })
        }
      });
      
    },
    // this.billGenerateFormFlag = true;
    // this.billGenerateForm.client = this.zhxx.householder;
    // this.billGenerateForm.roomName = this.communityName;
    // console.log(this.billGenerateForm);
    selectionChange(selection) {
      console.log(selection);
      // this.billPay.sumOfAmount = 0.00;
      let sumAmount = 0;
      this.selectionList = selection;
      this.payBillList = selection;
      // this.billPay.sumOfAmount = NP.strip(this._.sumBy(selection, 'billShouldAmount'));
      selection.forEach((element) => {
        sumAmount = parseFloat(sumAmount) + parseFloat(element.billShouldAmount);
      });
      this.totalShouldAmount = sumAmount.toFixed(2);
      let eleTag = document.querySelector('#fee20211117').querySelector('#sumAmount');
      if (selection.length == 0) {
        eleTag.innerHTML = sumAmount;
      } else {
        eleTag.innerHTML = sumAmount.toFixed(2);
      }
      this.billPay.feeBillList = selection;
    },
  },
};
</script>
<style scoped>
::v-deep .avue-crud__pagination {
  height: 32px;
}
#fee20211117 .el-input__icon {
  line-height: 32px;
}
#fee20211117 .el-table .cell {
  white-space: normal;
}
#fee20211117 .avue-crud .el-form-item {
  width: 100%;
}

.sum-tips {
  margin-bottom: 5px;
}

.sum-tips > span {
  margin-right: 50px;
}

.reduce-top > * {
  margin-right: 10px;
}
</style>
